import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchTrgReportTypes = getApiActionTypes('REPORTS/TRG/CUSTOM_REPORT');
export const runTrgReportTypes = getApiActionTypes('REPORTS/TRG/RUN_TRG_REPORT');
export const CLEAN_AFTER_TRG_REPORT = getApiActionTypes('REPORTS/TRG/CLEAN_AFTER_TRG_REPORT');
export const fetchParamOptionsTypes = getApiActionTypes('REPORTS/TRG/FETCH_PARAM_OPTIONS');
export const fecthEntityAnalyticalReviewReportTypes = getApiActionTypes(
  'REPORTS/FETCH_ENTITY_ANALYTICAL_REVIEW_REPORT',
);
export const fetchConsolidatedStateConsolidatedReportTypes = getApiActionTypes(
  'REPORTS/FETCH_CONSOL_STATE_CONSOLIDATED_REPORT',
);

export const fetchNexusConsolAnalysisReportTypes = getApiActionTypes(
  'REPORTS/FETCH_NEXUS_CONSOL_REPORT',
);

export const fetchInterCompanyDividendAnalysisReportTypes = getApiActionTypes(
  'REPORTS/FETCH_INTERCOMPANY_DIVIDEND_REPORT',
);

export const fetchConsolSTISummaryPushbackStateReportTypes = getApiActionTypes(
  'REPORTS/FETCH_CONSOL_STI_SUMMARY_PUSHBACK_STATE_REPORT',
);

export const fetchConsolSTIReconciliationReportTypes = getApiActionTypes(
  'REPORTS/FETCH_CONSOL_STI_RECONCILIATION_REPORT',
);
